import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const GeoIcon = ({
  width = "14",
  height = "14",
  color = "#464646",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99922 4.1125C7.34732 4.1125 7.68116 4.25078 7.9273 4.49692C8.17344 4.74306 8.31172 5.0769 8.31172 5.425C8.31172 5.59736 8.27777 5.76803 8.21181 5.92727C8.14585 6.08651 8.04917 6.2312 7.9273 6.35308C7.80542 6.47496 7.66073 6.57163 7.50149 6.63759C7.34225 6.70355 7.17158 6.7375 6.99922 6.7375C6.65112 6.7375 6.31728 6.59922 6.07114 6.35308C5.825 6.10694 5.68672 5.7731 5.68672 5.425C5.68672 5.0769 5.825 4.74306 6.07114 4.49692C6.31728 4.25078 6.65112 4.1125 6.99922 4.1125ZM6.99922 1.75C7.97389 1.75 8.90864 2.13719 9.59784 2.82638C10.287 3.51558 10.6742 4.45033 10.6742 5.425C10.6742 8.18125 6.99922 12.25 6.99922 12.25C6.99922 12.25 3.32422 8.18125 3.32422 5.425C3.32422 4.45033 3.71141 3.51558 4.4006 2.82638C5.0898 2.13719 6.02455 1.75 6.99922 1.75ZM6.99922 2.8C6.30303 2.8 5.63535 3.07656 5.14306 3.56884C4.65078 4.06113 4.37422 4.72881 4.37422 5.425C4.37422 5.95 4.37422 7 6.99922 10.5227C9.62422 7 9.62422 5.95 9.62422 5.425C9.62422 4.72881 9.34766 4.06113 8.85537 3.56884C8.36309 3.07656 7.69541 2.8 6.99922 2.8Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
